/* UIkit component extensions — entry point
 *
 * Each section extends one UIkit component via UIkit.mixin().
 * Only this file is listed in angular.json scripts.
 */

/* ─── uk-grid ────────────────────────────────────────────────────────────────
 *
 * Inserts .uk-grid-row-divider elements at every row boundary inside a
 * uk-grid-divider grid. The mixin runs inside UIkit's own update pipeline so
 * uk-first-column or uk-grid-margin are already stamped before our write().
 *
 * Two paths:
 *  • reposition — row count unchanged → update style.top/left/width only.
 *                  No DOM node changes → UIkit's childList observer is silent
 *                  → resize updates flow freely without any busy flag.
 *  • rebuild — row count changed → clear + re-append with a two-frame
 *                  busy flag to absorb UIkit's single childList reaction.
 */
(function () {
    'use strict';

    if (typeof UIkit === 'undefined') return;

    var CLS       = 'uk-grid-row-divider';
    var CLS_DIVIDER = 'uk-grid-divider';
    var CLS_STACK  = 'uk-grid-stack';
    var CLS_FIRST  = 'uk-first-column';
    var CLS_MARGIN = 'uk-grid-margin';

    function halfGapOf(item) {
        return parseFloat(getComputedStyle(item).marginTop) / 2;
    }

    function getNewRowItems(el) {
        var result   = [];
        var children = el.children;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (
                !child.classList.contains(CLS) &&
                child.classList.contains(CLS_FIRST) &&
                child.classList.contains(CLS_MARGIN)
            ) {
                result.push(child);
            }
        }
        return result;
    }

    function clearDividers(el) {
        var existing = el.querySelectorAll('.' + CLS);
        for (var i = 0; i < existing.length; i++) existing[i].remove();
    }

    function geometry(el) {
        var leftOffset = Math.abs(parseFloat(getComputedStyle(el).marginLeft)) || 0;
        return { left: leftOffset, width: el.offsetWidth - leftOffset };
    }

    UIkit.mixin({
        update: [
            {
                // read runs after UIkit's grid read (uk-first-column / uk-grid-margin
                // already stamped), so offsetTop values are current layout.
                read: function () {
                    var el = this.$el;

                    if (this._rowDividerBusy) return false;

                    if (el.classList.contains(CLS_STACK) || !el.classList.contains(CLS_DIVIDER)) {
                        return { clear: true };
                    }

                    return {
                        clear:        false,
                        newRowItems:  getNewRowItems(el),
                        dividerCount: el.querySelectorAll('.' + CLS).length,
                        geo:          geometry(el)
                    };
                },

                write: function (data) {
                    if (data === false) return;

                    var el = this.$el;

                    if (data.clear) {
                        clearDividers(el);
                        return;
                    }

                    var newRowItems      = data.newRowItems;
                    var existingDividers = el.querySelectorAll('.' + CLS);
                    var geo              = data.geo;

                    if (newRowItems.length === existingDividers.length) {
                        // ── Reposition path ──────────────────────────────────
                        for (var r = 0; r < existingDividers.length; r++) {
                            var ri = newRowItems[r];
                            var rd = existingDividers[r];
                            rd.style.top   = (ri.offsetTop - halfGapOf(ri)) + 'px';
                            rd.style.left  = geo.left + 'px';
                            rd.style.width = geo.width + 'px';
                        }
                        return;
                    }

                    // ── Rebuild path ──────────────────────────────────────────
                    clearDividers(el);

                    if (newRowItems.length === 0) return;

                    this._rowDividerBusy = true;
                    var self = this;
                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            self._rowDividerBusy = false;
                        });
                    });

                    for (var j = 0; j < newRowItems.length; j++) {
                        var item    = newRowItems[j];
                        var divider = document.createElement('div');
                        divider.className = CLS;
                        divider.style.top   = (item.offsetTop - halfGapOf(item)) + 'px';
                        divider.style.left  = geo.left + 'px';
                        divider.style.width = geo.width + 'px';
                        el.appendChild(divider);
                    }
                },

                events: ['resize', 'load']
            }
        ]
    }, 'grid');

}());
